import { AppClientEffects } from './app-client.effects';
import { AppRouterEffects } from './app-router.effects';
import { AppUserEffects } from './app-user.effects';
import { AppEffects } from './app.effects';
import { EntitlementsEffects } from './entitlements.effects';
import { ResellerEffects } from './reseller.effects';
import { SiteMapEffects } from './site-map.effects';
import { StatusEffects } from './status.effects';

export const appEffects = [
  AppClientEffects,
  AppRouterEffects,
  AppUserEffects,
  AppEffects,
  EntitlementsEffects,
  ResellerEffects,
  SiteMapEffects,
  StatusEffects,
];
